export async function get_channel_config(channel, process, websocket_handler) {
    return new Promise(async (resolve, reject) => {
        await websocket_handler.wait();
        try {
            const subscriptionChannelName = process == "subscribe" ? "channel-subscribe" : "channel-presence";
            websocket_handler.pushForSecureLine(subscriptionChannelName, {
                "channel": channel
            });
            let { channelConfig: rawData, snapshot } = await websocket_handler.listenForSecureLine(subscriptionChannelName, (sdata) => {
                if (sdata['status'] == 'not-OK') {
                    reject(sdata['error']);
                }
                return true;
            });
            if (rawData) {
                const channelConfig = {
                    channelName: channel,
                    channelType: rawData.TypeofChannel,
                    snapshot: snapshot
                };
                resolve(channelConfig);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}
export async function get_interceptor_config(interceptor, websocket_handler) {
    return new Promise(async (resolve, reject) => {
        await websocket_handler.wait();
        try {
            websocket_handler.pushForSecureLine("interceptor-subscribe", { "interceptor": interceptor });
            let { interceptorConfig } = await websocket_handler.listenForSecureLine('interceptor-subscribe', (sdata) => {
                if (sdata['status'] == 'not-OK') {
                    reject(sdata['error']);
                }
                return true;
            });
            resolve(interceptorConfig);
        }
        catch (error) {
            reject(error);
        }
    });
}
